import React, { useState } from 'react';
import { ChevronUpIcon, ChevronDownIcon, Heart, CreditCard, Wallet } from 'lucide-react';
import { bankInfo } from './bancaria.js';

const DonationBanner = () => {
  const [isMinimized, setIsMinimized] = useState(true);

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      <div className="bg-blue-50 shadow-lg">
        {/* Header siempre visible */}
        <div 
          className="cursor-pointer hover:bg-blue-100/50 transition-colors border-b"
          onClick={() => setIsMinimized(!isMinimized)}
        >
          <div className="max-w-7xl mx-auto px-4">
            <div className="flex justify-between items-center h-14">
              <div className="flex items-center space-x-2">
                <Heart className="text-blue-600" size={24} />
                <h2 className="text-xl font-semibold text-gray-800">Donaciones</h2>
              </div>
              <button className="text-gray-500 hover:text-gray-700 p-2 rounded-full">
                {isMinimized ? <ChevronUpIcon className="w-6 h-6" /> : <ChevronDownIcon className="w-6 h-6" />}
              </button>
            </div>
          </div>
        </div>

        {/* Contenido expandible */}
        {!isMinimized && (
          <div className="bg-white">
            <div 
              className="max-w-7xl mx-auto px-4 py-6 overflow-y-auto"
              style={{
                maxHeight: 'calc(100vh - 300px)',
                WebkitOverflowScrolling: 'touch', // Para mejor scroll en iOS
                overscrollBehavior: 'contain'      // Previene scroll indeseado
              }}
            >
              {/* Contenido principal */}
              <div className="max-w-2xl mx-auto space-y-6">
                {/* Mensaje de agradecimiento */}
                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">¡Gracias por tu apoyo!</h3>
                  <p className="text-gray-600 mb-4">
                    Si has llegado hasta aquí, queremos agradecerte de corazón. Tu interés en hacer una donación a Salva Patas demuestra tu compromiso con nuestra causa y nos llena de esperanza.
                  </p>
                </div>

                {/* Scotiabank */}
                <div className="bg-blue-50 p-4 rounded-lg">
                  <div className="flex items-center space-x-2 mb-3">
                    <CreditCard className="text-blue-600" size={24} />
                    <h4 className="text-lg font-semibold">{bankInfo.scotiabank.bankName}</h4>
                  </div>
                  <div className="space-y-3">
                    <div>
                      <p className="text-gray-600 text-sm mb-1">Titular:</p>
                      <div className="relative">
                        <input
                          type="text"
                          value={bankInfo.scotiabank.accountHolder}
                          readOnly
                          className="w-full bg-white px-3 py-2 rounded border text-gray-700"
                          onClick={(e) => e.target.select()}
                        />
                      </div>
                    </div>
                    <div>
                      <p className="text-gray-600 text-sm mb-1">Número de cuenta:</p>
                      <div className="relative">
                        <input
                          type="text"
                          value={bankInfo.scotiabank.accountNumber}
                          readOnly
                          className="w-full bg-white px-3 py-2 rounded border text-gray-700"
                          onClick={(e) => e.target.select()}
                        />
                      </div>
                    </div>
                    <div>
                      <p className="text-gray-600 text-sm mb-1">CCI:</p>
                      <div className="relative">
                        <input
                          type="text"
                          value={bankInfo.scotiabank.cci}
                          readOnly
                          className="w-full bg-white px-3 py-2 rounded border text-gray-700"
                          onClick={(e) => e.target.select()}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Yape/PLIN */}
                <div className="bg-blue-50 p-4 rounded-lg">
                  <div className="flex items-center space-x-2 mb-3">
                    <Wallet className="text-blue-600" size={24} />
                    <h4 className="text-lg font-semibold">{bankInfo.yapePlin.name}</h4>
                  </div>
                  <div>
                    <p className="text-gray-600 text-sm mb-1">Titular:</p>
                    <div className="relative">
                      <input
                        type="text"
                        value={bankInfo.yapePlin.accountHolder}
                        readOnly
                        className="w-full bg-white px-3 py-2 rounded border text-gray-700"
                        onClick={(e) => e.target.select()}
                      />
                    </div>
                  </div>
                  <div>
                    <p className="text-gray-600 text-sm mb-1">Número:</p>
                    <div className="relative">
                      <input
                        type="text"
                        value={bankInfo.yapePlin.number}
                        readOnly
                        className="w-full bg-white px-3 py-2 rounded border text-gray-700"
                        onClick={(e) => e.target.select()}
                      />
                    </div>
                  </div>
                </div>

                {/* Espaciador inferior para iOS */}
                <div className="h-8 md:h-0" />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DonationBanner;